module.exports = __webpack_public_path__ + "2fe2efe63441d830b1acd106c1fe8734.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Simple-Line-Icons.svg
// module id = 288
// module chunks = 0